import { makeStyles } from '@fluentui/react-components';

export const useCopilotIconStyles = makeStyles({
  copilotIcon: {
    paddingTop: '4px',
    paddingRight: '4px',
    paddingLeft: '4px',
  },
});
